var map = {
	"./add_menu_edit_no_image.png": "7Esd",
	"./fonts/DB Heavent/DB Heavent Bd It v3.2.ttf": "qGZu",
	"./fonts/DB Heavent/DB Heavent Bd v3.2.ttf": "DRVs",
	"./fonts/DB Heavent/DB Heavent Blk It v3.2.ttf": "4W/5",
	"./fonts/DB Heavent/DB Heavent Blk v3.2.ttf": "8Jt6",
	"./fonts/DB Heavent/DB Heavent It v3.2.ttf": "Vq2R",
	"./fonts/DB Heavent/DB Heavent Li It v3.2.ttf": "QihJ",
	"./fonts/DB Heavent/DB Heavent Li v3.2.ttf": "opQ+",
	"./fonts/DB Heavent/DB Heavent Med It v3.2.ttf": "BNga",
	"./fonts/DB Heavent/DB Heavent Med v3.2.ttf": "RSWM",
	"./fonts/DB Heavent/DB Heavent Thin It v3.2.ttf": "DpQT",
	"./fonts/DB Heavent/DB Heavent Thin v3.2.ttf": "g0nn",
	"./fonts/DB Heavent/DB Heavent UlLi It v3.2.ttf": "xkB4",
	"./fonts/DB Heavent/DB Heavent UlLi v3.2.ttf": "eCf6",
	"./fonts/DB Heavent/DB Heavent v3.2.ttf": "e5sp",
	"./gif/menu-loading.gif": "iXUA",
	"./icons/basket.png": "56dC",
	"./icons/card/carddemo.png": "Nidu",
	"./icons/card/jcb.png": "Ctzb",
	"./icons/card/master-logo.png": "cp/P",
	"./icons/card/mastercard.png": "tpay",
	"./icons/card/unionpay.png": "8EzH",
	"./icons/card/visa.png": "5bHX",
	"./icons/cart.png": "03m6",
	"./icons/chevron.png": "UwdW",
	"./icons/clock.png": "V3LL",
	"./icons/complete-suggestion.png": "2xYK",
	"./icons/credit.png": "o03I",
	"./icons/delivery@3x.png": "dFCv",
	"./icons/delivery_active.png": "vXId",
	"./icons/delivery_active@3x.png": "9vHh",
	"./icons/delivery_inactive.png": "7p5N",
	"./icons/delivery_inactive@3x.png": "/i5v",
	"./icons/disable-basket.png": "70Nh",
	"./icons/driver-delivery.png": "qNXw",
	"./icons/edit.png": "LLfo",
	"./icons/empty-order.png": "k5wQ",
	"./icons/empty_search.png": "OvaN",
	"./icons/en.jpg": "YsLJ",
	"./icons/en_no_background.png": "tAsh",
	"./icons/face-404.png": "EkzC",
	"./icons/facebook.png": "XQRD",
	"./icons/flag-aus.png": "s7FT",
	"./icons/flag-ger.png": "m8hs",
	"./icons/flag-india.svg": "eDqP",
	"./icons/flag-laos.png": "yDSN",
	"./icons/flag-myanmar.svg": "qTpv",
	"./icons/flag-thai.png": "k0l8",
	"./icons/gps.png": "IPj3",
	"./icons/heart.png": "1hKp",
	"./icons/logo_fs.png": "VXrQ",
	"./icons/logo_sm.png": "0Hcj",
	"./icons/logobig.png": "onC5",
	"./icons/logout.png": "t5TJ",
	"./icons/minimum-price.png": "SRwd",
	"./icons/moreInfo.png": "vNHc",
	"./icons/noun_location.png": "Nrbm",
	"./icons/online-order.png": "9KMT",
	"./icons/over-distance.png": "YoH9",
	"./icons/paid.png": "Ulaa",
	"./icons/phone.png": "zruR",
	"./icons/pickup@3x.png": "h6pG",
	"./icons/pickup_active.png": "VIzF",
	"./icons/pickup_inactive.png": "OjwX",
	"./icons/pin.png": "gDMn",
	"./icons/pin2.png": "abDu",
	"./icons/preorder.png": "hlrs",
	"./icons/profile-w.png": "sXGF",
	"./icons/profile.png": "u88E",
	"./icons/receipt-w-noti.png": "4jfC",
	"./icons/receipt-w.png": "LP0X",
	"./icons/receipt.png": "/njR",
	"./icons/receipt_noti.png": "1EOU",
	"./icons/restaurant_close.png": "O/sv",
	"./icons/search-w.png": "gF1C",
	"./icons/search.png": "9uNU",
	"./icons/shape-up.png": "67kh",
	"./icons/shape.png": "9QKS",
	"./icons/shield.png": "6Yab",
	"./icons/svg/call.svg": "ip21",
	"./icons/svg/clock.svg": "8p7B",
	"./icons/svg/delivery-active.svg": "ReUb",
	"./icons/svg/delivery-gray.svg": "TTSH",
	"./icons/svg/direction-circle.svg": "XOuz",
	"./icons/svg/empty-menu.svg": "aWy5",
	"./icons/svg/facebook.svg": "/MQe",
	"./icons/svg/gps-fixed.svg": "Q/9S",
	"./icons/svg/infomation.svg": "zPWe",
	"./icons/svg/line.svg": "yCAs",
	"./icons/svg/location-setting.svg": "j+Tx",
	"./icons/svg/logo-foodstory.svg": "nOWJ",
	"./icons/svg/map-sm.svg": "3sS/",
	"./icons/svg/pickup-active.svg": "lZMU",
	"./icons/svg/pin-active.svg": "sOt9",
	"./icons/svg/pin-inactive.svg": "/fj0",
	"./icons/svg/pin.svg": "YWt/",
	"./icons/svg/pointer-active.svg": "3FQr",
	"./icons/svg/warning-circle.svg": "Yp5j",
	"./icons/th.jpg": "/CGA",
	"./icons/th_no_background.png": "HDN1",
	"./icons/thank/call.png": "5PId",
	"./icons/thank/cancelorder.png": "RnmP",
	"./icons/thank/cash.png": "Khnu",
	"./icons/thank/confirm.png": "e3yu",
	"./icons/thank/creditcard.png": "UrqH",
	"./icons/thank/default_cover.png": "flCV",
	"./icons/thank/dot.png": "WiAq",
	"./icons/thank/fail.png": "tAIo",
	"./icons/thank/from_res.png": "MhI2",
	"./icons/thank/icon-promptpay.png": "d1Nw",
	"./icons/thank/line.png": "H39o",
	"./icons/thank/map.png": "Sggd",
	"./icons/thank/messenger.png": "9M/y",
	"./icons/thank/orderpickedup.png": "b+nI",
	"./icons/thank/pin.png": "yki/",
	"./icons/thank/preparing_active.png": "u8m/",
	"./icons/thank/preparing_inactive.png": "JFoi",
	"./icons/thank/scb.png": "JhEu",
	"./icons/thank/step3_active.png": "j+aj",
	"./icons/thank/step3_interactive.png": "28m2",
	"./icons/upload-success-en.png": "2/II",
	"./icons/upload-sucess.jpg": "BgwU",
	"./icons/vector.png": "7NO4",
	"./logo.png": "7Otq"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PvXa";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = PvXa
// module chunks = 1